/* @flow */

import React from 'react';
import InfiniteScroll from 'depop/components/InfiniteScroll';

import Ball from 'depop/components/loaders/Ball';

type Props = {
  children: React.Element,
  hasMore: boolean,
  loadMore: () => void,
  disablePaging: boolean,
  useWindow: boolean,
};

const SimpleInfiniteScroll = ({
  children,
  hasMore,
  loadMore,
  disablePaging,
  useWindow = true,
}: Props) =>
  <InfiniteScroll
    style={{ width: '100%' }}
    pageStart={0}
    loadMore={loadMore}
    disablePaging={disablePaging}
    hasMore={hasMore}
    loader={<Ball />}
    useWindow={useWindow}
    threshold={500}>
    {children}
  </InfiniteScroll>;

export default SimpleInfiniteScroll;



// WEBPACK FOOTER //
// ../src/client/components/SimpleInfiniteScroll.js